import { search } from "../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findBancos() {
  const path = `${process.env.REACT_APP_URL_API_ERP_V3}/main/financeiro/bancos?perPage=500`;
  return search(decodeURIComponent(path), "GET", headers);
}
